import {
    wow_doctor
  } from "../../js/path";
  
  export default {
    data() {
      return {
        showTransactionModal: false,
        transactionList: [],
        editedRowId: null,
        existingTokens: 0,
        addTokens: 0,
        member_tagging : null,
        memberList: [],
        aiServiceList: [],
        pageNo: null,
        status: false,
        ai_services: [],
        commuinityStatus: false,
        posts_id: this.$route.params.id,
        table_header: [],
        fields: [{
            key: "_id",
            sortable: true,
          },
          {
            key: "note",
            label: 'Note'
          },
          {
            key: "credits",
            label: "Credits"
          },
          {
            key: "credits_balance",
            label: 'Balance'
          },
          {
            key: "transaction_type",
            label: "Type"
          },
        ],
        params: "",
        tableData: [],
        activeTab: "all",
        key: 0,
        currentPage: 1,
        filter: null,
        filterOn: [],
        sortBy: "id",
        sortDesc: true,
        selected_plans: "all",

      filter_plan_options: [
        { value: "all", label: "All" },
        { value: "credit", label: "Credit" },
        { value: "debit", label: "Debit" },
      ],
      };
    },
    methods: {
      capitalize(text) {
        if (!text) return '';
        return text.charAt(0).toUpperCase() + text.slice(1);
      },
      enableTokenEdit(item) {
        this.editedRowId = item.id;
        this.existingTokens = item.tokens ?? 0;
        this.addTokens = 0;
      },
      filterPage() {
        if (this.pageNo.length > 0) {
          this.params = `&page=${this.pageNo}`;
          this.fetchData(this.activeTab);
          this.currentPage = this.pageNo;
        }
      },
      searchFor() {
        this.currentPage = 1;
        this.fetchData();
      },
      search(event) {
        if (event.keyCode === 13) {
          this.currentPage = 1;
          this.fetchData();
        }
      },
      onPageChange(page) {
        this.currentPage = page;
        this.fetchData();
      },
      async fetchData(txt = "all") {
        this.activeTab = txt || "all";

        console.log("test", this.posts_id);

        this.$store.commit("loader/updateStatus", true);

        try {
          let url = `${wow_doctor.wowDoctorCredithistoryUrl}?doctorId=${this.posts_id}` +
            `&page=${this.currentPage || 1}` +
            `&size=20`;

          // ✅ SEARCH
          if (this.filter) {
            url += `&search=${this.filter}`;
          }
          console.log("selected_plans in fetchData:", this.selected_plans);

          // ✅ DROPDOWN FILTER (IMPORTANT FIX)
          if (this.selected_plans !== "all") {
          url += `&filter=${this.selected_plans}`;
        }

          const data = await this.getRequest(url);

          if (data.status) {
            this.tableData = data.data;
            console.log("data", this.tableData);
          }

        } catch (err) {
          this.$store.commit("toast/updateStatus", {
            status: true,
            icon: "error",
            title: err?.data?.message || "Please try again!",
          });
        }

        this.$store.commit("loader/updateStatus", false);
        this.key++;
      },          
      getUrl() {
        this.$router.replace({
          name: this.$route.name,
          params: {
            id: this.$route.params.id,
          },
          query: {
            filter: this.activeTab || "all",
            search: this.filter || undefined,
            page: this.currentPage || 1,
          },
        });
      },
      async showTransaction(id){
        const url = wow_doctor.wowDoctorCredithistoryUrl;
        const data = await this.getRequest(url + "/" + id);
        if(data.status){
          this.showTransactionModal = true;
          this.transactionList = data.response.data;
          console.log(this.transactionList);
        }
      }      
    },
    watch: {
      currentPage() {
        this.fetchData();
      },

      activeTab() {
        this.currentPage = 1;   // reset page
        this.fetchData();       // call API
      },

      filter() {
        this.currentPage = 1;
        this.fetchData();
      },

      "$route.query": {
        immediate: true,
        handler(query) {
          this.activeTab = query.filter || "all";
          this.filter = query.search || "";
          this.currentPage = Number(query.page || 1);

          this.fetchData();
        }
      },
      selected_plans(newVal) {
        console.log("Selected Plan Changed:", newVal);

        this.currentPage = 1;
        this.fetchData();
      }
    },
    created() {
      this.posts_id = this.$route.params.id;

      this.activeTab = this.$route.query.filter || "all";
      this.filter = this.$route.query.search || "";
      this.currentPage = Number(this.$route.query.page || 1);

      this.fields.map((item) => {
        this.table_header.push(item.key);
      });
    }
  };